import * as React from 'react';
import injectSheet from 'react-jss';
import Tooltip from 'antd/lib/tooltip';
import ContainerDetails from './ContainerDetails/ContainerDetails';
import { renderInquiryOriginDetails, renderInquiryDestinationDetails } from './InquiryCommon';
import { commonStyles } from 'src/Library/CommonStyles';
import classNames from 'classnames';
import { tokens } from 'src/design-system';

const styles = (theme: any) => ({
  flexRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  absoluteData: {
    position: 'absolute',
    top: '24px',
  },
  ellipsis: {
    width: '110px',
    ...commonStyles(theme).ellipses,
  },
});

class ShipperBidMapCard extends React.Component<any, any>{
  renderDot = (style, char) => {
    return <div style={{
      marginBottom: '3px', height: '8px', width: '8px',
      borderRadius: `${tokens.radius.md}px`, display: 'inline-block',
      verticalAlign: 'middle',
      ...style,
    }}><span style={{ paddingLeft: '1px' }}>{char}</span></div>;
  }

  renderLine = (color) => {
    return <div style={{ display: 'flex', flex: 1, height: '1px', backgroundColor: color }}>
    </div>;
  }

  render() {
    const {
      classes,
      cardData: data,
      dividerColor,
      isCompareBidsModal,
    } = this.props;
    return (
    <>
      <div className={classes.flexRow} style={{
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '25px', marginTop: '4px',
        marginRight: '110px',
      }}>
        <div>
          {this.renderDot({ backgroundColor: dividerColor }, '')}
          <div className={classNames(classes.absoluteData, classes.ellipsis)} style={{
            width: isCompareBidsModal ? '70px' : '105px', left: '10px',
          }}>
            {renderInquiryOriginDetails(classes, data)}
          </div>
        </div>
        {this.renderLine('#D9D9D9')}
        <ContainerDetails data={data} />
        {this.renderLine('#D9D9D9')}
        <div>
          {this.renderDot({ border: `1px solid ${dividerColor}` }, '')}
          <br />
          <div className={classNames(classes.absoluteData, classes.ellipsis)}>
            {renderInquiryDestinationDetails(classes, data)}
          </div>
        </div>
      </div>
    </>
    );
  }
}

export default injectSheet(styles)(ShipperBidMapCard);
